import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import commonMessages from 'common/messages/messages';
import QuestionnaireModal from '../QuestionnaireModal/QuestionnaireModal';

interface IChangeActiveStatusModal {
  isActive: boolean;
  title: string;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const ChangeActiveStatusModal: FC<IChangeActiveStatusModal> = ({
  isActive,
  title,
  isLoading,
  onClose,
  onSubmit,
}) => {
  const intl = useIntl();
  const titleMsg = isActive ? commonMessages.deactivateItem : commonMessages.activateItem;
  const submitBtnMsg = isActive ? commonMessages.deactivateBtn : commonMessages.activateBtn;

  return (
    <QuestionnaireModal
      title={intl.formatMessage(titleMsg, { name: title })}
      submitBtnTitle={intl.formatMessage(submitBtnMsg)}
      onClose={onClose}
      onSubmit={onSubmit}
      isLoading={isLoading}
      isOpen
    />
  );
};

export default ChangeActiveStatusModal;
